<template>
  <PageHeader :title="field.name || 'New Field'" :subtitle="customer.name" icon="mdi-flower-outline" @subtitle="toField" @back="toField" @save="submit" back save :valid='formValid' >

    <v-form>

      <FormContainer color="blue lighten-5">

        <v-container fluid class="py-0 px-2">
          <v-row>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['FieldLocation']" title="Ubicación del campo" description="¿Es el campo susceptible a inundaciones o represas de agua?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['Altitude']" title="Altitud" description="¿Es la altitud sobre el nivel del mar ideal para cultivar la variedad de chile recomendada?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['DryZone']" title="Zona seca" description="¿Hay un nivel bajo de precipitación de agua de lluvia?"  /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['WaterAvailability']" title="Disponibilidad de agua" description="¿La finca tiene buena disponibilidad de agua (ríos, arroyos, embalses)?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['SoilAnalysis']" title="Análisis de suelo" description="¿El suelo tiene menos del 40% de arcilla o buena capacidad de drenaje?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['Owner']" title="Dueño" description="¿El agricultor es propietario de la tierra o tiene un contrato de alquiler regular?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['DripIrrigation']" title="Riego por goteo" description="¿El campo o finca ya tiene instalado un sistema de riego por goteo?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['LabourAvailable']" title="Labor manual" description="¿Hay suficiente mano de obra cerca o en la finca para los períodos de siembra y cosecha?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['Experience']" title="Experiencia agrícola" description="¿El agricultor tiene buena experiencia agrícola?" /></v-col>
            <v-col cols="12" sm="4"><StarRatingCard v-model="assessment['FinancialResources']" title="Recursos financieros" description="¿El agricultor tiene buenos recursos económicos?" /></v-col>

            <v-col cols="12">
              <v-textarea label="Observaciones" v-model="assessment.Observations" auto-grow ></v-textarea>
            </v-col>
            
          </v-row>
        </v-container>

      </FormContainer>
    </v-form>

  </PageHeader>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid';

  import PageHeader from '@/components/PageHeader';
  import FormContainer from '@/components/FormContainer';
  import StarRatingCard from '@/components/StarRatingCard';

  export default {
    components: { PageHeader, FormContainer, StarRatingCard },
    data: () => ({
      assessment: {
        uuid: uuidv4(),
        Observations: ''
      },
    }),
    computed: {
      customerUuid() { return this.$route.query.uuid; },
      fieldUuid() { return this.$route.query.fieldUuid; },
      customer() { return this.$store.getters.customer(this.customerUuid); },
      field() { return this.customer.fields.filter( f => f.uuid==this.fieldUuid )[0]; },
      formValid() { return Object.keys(this.assessment).length==12 }, // we already have two elements in the set: Observations and uuid
    },

    methods: {

      submit() {

        let score = 0;
        const results = this.assessment;

        score = score + results['FieldLocation'] * 0.13;
        score = score + results['Altitude'] * 0.08;
        score = score + results['DryZone'] * 0.1;
        score = score + results['WaterAvailability'] * 0.12;
        score = score + results['SoilAnalysis'] * 0.12;
        score = score + results['Owner'] * 0.05;
        score = score + results['DripIrrigation'] * 0.13;
        score = score + results['LabourAvailable'] * 0.09;
        score = score + results['Experience'] * 0.09;
        score = score + results['FinancialResources'] * 0.09;

        score = Math.round(score);
        this.field.score = score;
        results['_score'] = score;

        this.field.assessmentScores = this.field.assessmentScores || [];
        this.field.assessmentScores.push(results);

        if (this.field.status==='new') { this.field.status = 'assessed'; }
        this.field.scoredAt = new Date().toISOString();

        this.$store.dispatch('upsertCustomer', this.customer);
        
        this.toField();

      },

      toField() { this.$router.push({name: 'Field', query: { uuid: this.customerUuid, fieldUuid: this.field.uuid }}); },
      
    }
  }
  
</script>